import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateCategoryApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateCategory = createAsyncThunk('updateCategory', async (payload) => {
  return await updateCategoryApi(payload);
});

const updateCategorySlice = createSlice({
  name: 'updateCategory', // Unique Name
  initialState,
  reducers: {
    updateCategoryReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCategory.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateCategory.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateCategoryReset } = updateCategorySlice.actions;

export default updateCategorySlice.reducer;
